import React from "react"
import { useNavigate } from "react-router-dom"
import MenuItem from "@mui/material/MenuItem"
import Avatar from "@mui/material/Avatar"
import { useVenue } from "@/contexts/venue"
import Link from "@mui/material/Link"
import { useDropdownContext, DropdownMenu } from "@/shared/dropdown"
import { useStore } from "@/store"
import { usePanelLink } from "@/shared/hooks"

export const UserAvatar = () => {
  const { currentUser } = useStore()
  const navigate = useNavigate()
  const linkTo = usePanelLink()

  const handleClick = () => {
    navigate(linkTo("settings"))
  }

  return (
    <Avatar
      onClick={handleClick}
      className="cursor-pointer mt-2 mb-4"
      src={currentUser.avatarUrl}
      data-testid="panel-sidebar-user-avatar"
    />
  )
}

export const VenueAvatar = () => {
  const { venue, venues } = useVenue()
  const { handleClick } = useDropdownContext()

  const venueAvatar = venue.images.find((img) => img.kind === "venue_logo")?.url
  const clickable = venues.length > 1
  const onClick = clickable ? handleClick : undefined

  return (
    <Avatar
      onClick={onClick}
      className={clickable ? "cursor-pointer mb-6" : "mb-6"}
      src={venueAvatar}
      data-testid="panel-sidebar-venue-avatar"
    >
      {venue?.name[0]}
    </Avatar>
  )
}

export const VenueDropdownMenu = () => {
  const { venues } = useVenue()

  return (
    <DropdownMenu classes={{ paper: "min-w-[200px]" }} data-testid="panel-topbar-venue-dropdown">
      {venues.map((venue) => (
        <MenuItem
          key={venue.id}
          component={Link}
          href={`/panel/${venue.slug}`}
          data-testid={`panel-topbar-venue-item-${venue.slug}`}
        >
          {venue.name}
        </MenuItem>
      ))}
    </DropdownMenu>
  )
}
